import Link from 'next/link'
import { CardLogo } from '@cerifi/contentful/__generated/graphql.types'

import { SmartImage } from '../../components/smart-image'
import { cn } from '../../utils/cn'

interface LogoCardProps {
  card: CardLogo
  showBackground?: boolean
  layoutOption: string
}

export const LogoCardCms = ({
  card,
  showBackground,
  layoutOption,
}: {
  card: any
  showBackground?: boolean
  layoutOption?: string
}) => {
  const CardBody = () => (
    <div className={showBackground ? 'bg-neutral-100' : ''}>
      <SmartImage
        className="mx-auto h-[9.75rem]"
        style={{ objectFit: 'contain' }}
        alt={card.logo?.description}
        pixelatedUrl={card.logo?.pixelatedUrl}
        src={card.logo?.url}
      ></SmartImage>
    </div>
  )

  if (layoutOption === 'grid') {
    return (
      // using the a tag instead of Next/link since next link component uses only client side navigation, which does not trigger the university nav in the layout to be updated until the next refresh
      <a
        href={cn(
          card.pageLink?.__typename === 'PageAffiliate'
            ? '/university/' + card.pageLink.slug
            : '/' + card.pageLink.slug
        )}
        aria-label={card.pageLink?.title}
        className="rounded-none"
        data-testid="logo-card"
      >
        <CardBody />
      </a>
    )
  } else {
    return <CardBody />
  }
}
